<app-documents-modal #modalComponent></app-documents-modal>

<div [formGroup]="filtroForm" class="card-body p-0 pt-4">
    <div class="d-flex justify-content-between pb-2">
        <h5 class="card-title mb-3">Todos os Projetos</h5>
        <div>
            <button (click)="voltar()" type="button" class="btn btn-soft-link waves-effect">Voltar</button>
            <button (click)="openNewProject()" class="btn btn-sm btn-primary">Iniciar Novo Projeto</button>
        </div>
    </div>

    <div class="table-responsive">
        <table
            class="table align-middle datatable dt-responsive table-check nowrap datatables table-striped table-bordered"
            style="border-collapse: collapse; border-spacing: 0 8px; width: 100%">
            <thead class="bg-light">
                <tr>
                    <th class="p-3">
                        <div class="d-flex flex-column">
                            <span class="fw-bold mb-2">Projeto</span>
                            <input formControlName="Descricao" type="text" class="form-control form-control-sm"
                                placeholder="Filtrar" aria-controls="tickets-table" />
                        </div>
                    </th>
                    <th class="p-3">
                        <div class="d-flex flex-column">
                            <span class="fw-bold mb-4">Status</span>
                            <select formControlName="Status" class="form-control form-control-sm">
                                <option value="">Filtrar</option>
                                <option value="1">Aprovado</option>
                                <option value="0">Iniciado</option>
                                <option value="2">Reprovado</option>
                            </select>
                        </div>
                    </th>
                    <th class="p-3">
                        <div class="d-flex flex-column">
                            <span class="fw-bold mb-4">Data Cadastro</span>
                        </div>
                    </th>

                    <th class="p-3 text-center actions-column">
                        <div class="d-flex flex-column">
                            <span class="fw-bold mb-4">Ações</span>
                        </div>
                    </th>
                </tr>
            </thead>

            <tbody>
                @if (projectService.loading) {
                <tr>
                    <td colspan="7" class="text-center position-relative">
                        <div class="d-flex justify-content-center align-items-center" style="height: 150px">
                            <span class="spinner-border" style="width: 3rem; height: 3rem" role="status"
                                aria-hidden="true"></span>
                        </div>
                    </td>
                </tr>
                }@else {
                @for (row of projetos; track $index) {
                <tr>
                    <td> {{ row.descricao }}</td>
                    <td>
                        <span class="badge p-2" [ngClass]="row.statusProjeto?.descricao! | statusCorFormatter:'cor'">{{ row.statusProjeto?.descricao! | statusCorFormatter:'nome' }}</span>
                    </td>
                    <td> {{ row.dataCadastro | date: "dd/MM/yyyy"}} </td>
                    <td class="text-center actions-column">
                        <div class="dropdown" ngbDropdown>
                            <button class="btn btn-link font-size-16 shadow-none py-0 text-muted dropdown-toggle"
                                type="button" ngbDropdownToggle aria-expanded="false">
                                <i class="bx bx-dots-horizontal-rounded"></i>
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                                <li>
                                    <button (click)="modalDocumentos(row)" class="dropdown-item"
                                        data-bs-target="#staticBackdrop" data-bs-toggle="modal">
                                        Ver Documentos
                                    </button>
                                    <button (click)="openNewProject(row)" class="dropdown-item"
                                        data-bs-target="#staticBackdrop" data-bs-toggle="modal">
                                        Editar Projeto
                                    </button>
                                    <button (click)="modalAtualizarStatus(row)" class="dropdown-item"
                                        data-bs-target="#staticBackdrop" data-bs-toggle="modal">
                                        Atualizar Status
                                    </button>
                                    <button (click)="onExcluir(row)" class="dropdown-item"
                                        data-bs-target="#staticBackdrop" data-bs-toggle="modal">
                                        Excluir
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </td>
                </tr>
                }}
            </tbody>
        </table>
    </div>

    <div class="row justify-content-md-between align-items-md-center mt-2">

        <div class="col">
            <div class="text-md-right float-md-end pagination-rounded">
                <ngb-pagination [collectionSize]="paginacao.totalDeItens" (pageChange)="onPageChange($event)"
                    [pageSize]="paginacao.quantidadePorPagina"></ngb-pagination>
            </div>
        </div>

    </div>


</div>